import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const NeedOnboarding = ({
  campaingId
}) => {
  return (
    <Fragment>
      <div className='col-12 border-color-ui-3 bg-white border radius'>
        <div className='checkout-step row px-1 py-2 border-bottom border-color-ui-3 '>
          <div className='col mr-auto'>
            <h1 className='txt-title txt-font-body txt-initial color-title mr-auto'>
              Necessario ter a verificação em duas etapas
            </h1>
          </div>
        </div>
        <div className='col-12 border-color-ui-3'>
          <a
            href={process.env.REACT_APP_ONBOARDING_ENDPOINT + campaingId}
            className='color-brand-1 mpos-relative t-1'
            title='Vai para tela de verificação em duas etapas'
          >
            Para efetuar a verificação em duas etapas clique aqui.
          </a>
          <div className='row px-0 pb-2 pt-half border-bottom border-color-ui-3' />
        </div>
      </div>
    </Fragment>
  )
}

NeedOnboarding.propTypes = {
  campaingId: PropTypes.string.isRequired
}

export default NeedOnboarding



// WEBPACK FOOTER //
// ./src/Participant/UraPassword/UnlockUraPassword/NeedOnboarding/NeedOnboarding.js